import { useTranslation } from "react-i18next";
const NoQuestions = () => {
	const { t } = useTranslation();
	return (
		<div className="flex flex-grow flex-col items-center justify-center gap-2 font-semibold text-secondary">
			<span className="italic">{t("live_page.no_questions")}</span>
		</div>
	);
};

export default NoQuestions;
